import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2bb53bae"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "person-head"
};
var _hoisted_2 = {
  class: "persontxt"
};
var _hoisted_3 = {
  style: {
    "display": "flex"
  }
};

var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, " 返回", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_arrow_left = _resolveComponent("arrow-left");

  var _component_el_icon = _resolveComponent("el-icon");

  var _component_arrow_right = _resolveComponent("arrow-right");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.title), 1), _createElementVNode("div", _hoisted_3, [_ctx.isranking ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    style: {
      "margin-right": "10px",
      "color": "#bf2020",
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.paihang();
    })
  }, "查看排行")) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", {
    class: "back",
    onClick: _cache[1] || (_cache[1] = //@ts-ignore
    function () {
      return _ctx.backfun && _ctx.backfun.apply(_ctx, arguments);
    })
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_arrow_left)];
    }),
    _: 1
  }), _hoisted_4, _createVNode(_component_el_icon, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_arrow_right)];
    }),
    _: 1
  })], 512), [[_vShow, _ctx.back]])]), _renderSlot(_ctx.$slots, "default", {}, undefined, true)]);
}